import { Parser } from "@json2csv/plainjs"
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@material-ui/core"
import { Add, GetApp } from "@material-ui/icons"
import * as FileSaver from "file-saver"
import PropTypes from "prop-types"
import React, { useContext, useEffect } from "react"
import { useQuery } from "react-query"
import { listAnalyticsUsers } from "~/actions/users"
import ListTitle from "~/components/Common/ListTitle"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AnalyticsCard from "~/components/Users/AnalyticsCard"
import AppContext from "~/contexts/App"
import usePermissionsRedirect from "~/hooks/usePermissionsRedirect"
import Page from "~/pages/Page"
import Router from "~/router"
import Box from "../../../../components/Common/Box"
import useStyles from "./styles"

const Analytics = ({ routes = [], ...rest }) => {
  const classes = useStyles()

  const { openDialog, setPageSubTitle, setPageTitle, openSnackBar } =
    useContext(AppContext)
  usePermissionsRedirect("/users/user-list", null, "super")

  const openCreateAnalyticsUser = () => {
    openDialog("createAnalyticsUserDialog")
  }

  const {
    data: analyticsUsers,
    refetch: refetchAnalyticsUsers,
    isLoading: analyticsUsesLoading,
  } = useQuery("analytics_users", () => listAnalyticsUsers(), {})

  //set admin  subtitle number
  useEffect(() => {
    setPageTitle("Analytics")
    setPageSubTitle(analyticsUsers?.length)
  }, [analyticsUsers])

  const downloadAnalyticsUsers = () => {
    const fields = ["name", "email", "client_count"]
    const opts = { fields }

    try {
      const parser = new Parser(opts)
      const csv = parser.parse(analyticsUsers)
      var file = new Blob([csv], { type: "text/csv" })
      FileSaver.saveAs(file, `anlytics-users.csv`)
    } catch (err) {
      openSnackBar({ message: "Error download admins data" })
    }
  }
  return (
    <Page>
      <Box className={classes.container}>
        <>
          <Box className={classes.leftContainer}>
            <Box marginLeft="16px" position="absolute" top="0" right="0">
              <PermissionsWrapper permissionGroup="admin">
                <Tooltip title="Download data" placement="top">
                  <IconButton onClick={downloadAnalyticsUsers}>
                    <GetApp color="secondary" />
                  </IconButton>
                </Tooltip>
              </PermissionsWrapper>
            </Box>

            <ListTitle
              list={[
                { name: "", size: "2%" },
                { name: "Name", size: "55%" },
                { name: "Email", size: "50%" },
                { name: "Client Count", size: "20%" },
                { name: "", size: "17%" },
              ]}
            />
            {analyticsUsesLoading ? (
              <Box display="flex" justifyContent="center">
                <CircularProgress size={30} />
              </Box>
            ) : (
              analyticsUsers?.map((x, i) => {
                return <AnalyticsCard analyticsUser={x} key={i} />
              })
            )}
          </Box>
          <Box className={classes.rightContainer}>
            <PermissionsWrapper permissionGroup="super">
              <Button
                onClick={openCreateAnalyticsUser}
                variant="contained"
                color="secondary"
                startIcon={<Add fontSize="small" />}
                style={{ height: "40px" }}
              >
                Invite
              </Button>
            </PermissionsWrapper>
          </Box>
        </>
      </Box>

      <Router routes={routes} {...rest} />
    </Page>
  )
}
Analytics.propTypes = {
  routes: PropTypes.array,
}
export default Analytics
